import React from "react"
import Tooltip from "../atoms/Tooltip.atom"
import { generateRandomNumber } from "../../utils/numbers.utils"
import { ReactComponent as CheckCircleOutlineRoundedIcon } from "../../design/assests/images/icons/check_circle.svg"

const CustomIconWithTooltipAndCustomBody = ({
  CustomIcon = CheckCircleOutlineRoundedIcon,
  tooltipBody = undefined,
  position = undefined,
  onClick = () => {}
}) => {
  const id = generateRandomNumber()
  const defaultPosition = "bottom"
  return (
    <>
      <Tooltip
        target={`.icon-tooltip-${id}`}
        position={position || defaultPosition}
      >
        {tooltipBody}
      </Tooltip>
      <CustomIcon className={`icon-tooltip-${id}`} onClick={onClick} />
    </>
  )
}

export default CustomIconWithTooltipAndCustomBody
